export class GetFormData {
  constructor() {
    const target = document.getElementById('js-form_title')
    if (!target) return
    const input = target.querySelector('input')
    const url = new URL(window.location.href)
    const params = url.searchParams
    const data = params.get('data')
    input.value = data
  }
}
